import { ref, onUnmounted } from 'vue';
import { socketService } from '@/services/socket.service';
import { CHANNELS, KDS_EVENTS } from '@/services/socket.events';


export function useKDSSocket({ branchId, onOrderCreated, onOrderStateUpdated, onItemCancelled, onItemDeleted, onItemUpdated, onItemsBulkCompleted, onReconnect }) {
  const channel = CHANNELS.kds(branchId);

  const isConnected = ref(socketService.isConnected());

  // ระหว่างที่หลุด (จอมือถือล็อก / เน็ตหาย) event ที่ broadcast ไปจะหายไปเลย — Pusher ไม่ replay
  // ให้ย้อนกลับมา "ต่อติดอีกครั้ง" เป็นสัญญาณว่าจอนี้ถือข้อมูลเก่า ต้อง resync
  let hasConnected = isConnected.value;
  const offChange = socketService.onConnectionChange((isUp) => {
    const wasDown = isConnected.value === false;
    isConnected.value = isUp;
    if (!isUp) return;
    // ต่อติดครั้งแรกตอน mount ไม่นับเป็น reconnect (หน้าจอเพิ่งโหลดรายการไปแล้ว)
    if (hasConnected && wasDown) onReconnect?.();
    hasConnected = true;
  });

  socketService.subscribe(channel);

  const offOrderCreated = socketService.on(channel, KDS_EVENTS.ORDER_CREATED, (data) => {
    onOrderCreated?.(data);
  });

  const offOrderStateUpdated = socketService.on(channel, KDS_EVENTS.ORDER_STATE_UPDATED, (data) => {
    onOrderStateUpdated?.(data);
  });

  const offItemCancelled = socketService.on(channel, KDS_EVENTS.ITEM_CANCELLED, (data) => {
    onItemCancelled?.(data);
  });

  const offItemDeleted = socketService.on(channel, KDS_EVENTS.ITEM_DELETED, (data) => {
    onItemDeleted?.(data);
  });

  const offItemUpdated = socketService.on(channel, KDS_EVENTS.ITEM_UPDATED, (data) => {
    onItemUpdated?.(data);
  });

  const offItemsBulkCompleted = socketService.on(channel, KDS_EVENTS.ITEMS_BULK_COMPLETED, (data) => {
    onItemsBulkCompleted?.(data);
  });

  // ─── Cleanup ──────────────────────────────────────────────────────────────
  onUnmounted(() => {
    offChange();
    offOrderCreated();
    offOrderStateUpdated();
    offItemCancelled();
    offItemDeleted();
    offItemUpdated();
    offItemsBulkCompleted();
    socketService.unsubscribe(channel);
  });

  return {
    isConnected,
    // ให้จอเรียกตอนกลับมาเห็นหน้าจอ — ปลุก socket ที่ค้างอยู่หลังมือถือหลับ
    ensureConnected: () => socketService.ensureConnected(),
  };
}
